var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.206 7.73128C17.1038 7.51857 16.8888 7.38281 16.652 7.38281H12.7251L15.9719 0.890408C16.0668 0.699932 16.0572 0.473443 15.9454 0.29199C15.8325 0.110537 15.6343 0 15.4216 0H8.03874C7.7828 0 7.55328 0.159223 7.46317 0.398959L3.77176 10.2427C3.70085 10.432 3.7273 10.6435 3.84145 10.8093C3.95682 10.9751 4.14545 11.0742 4.34733 11.0742H8.48093L6.21104 20.2358C6.14136 20.5163 6.27593 20.8077 6.53548 20.9363C6.79424 21.0639 7.10732 20.9953 7.28889 20.7693L17.1326 8.38257C17.2805 8.19751 17.3093 7.94456 17.206 7.73128Z",
    fill: "url(#paint0_linear_7_7071)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_7071",
    x1: 10.5,
    y1: 21,
    x2: 10.5,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.ced07d305aec41016e7552d14b517509.svg";
export { ForwardRef as ReactComponent };